import { render } from "./ClientsListView.vue?vue&type=template&id=6a0777f8&scoped=true"
import script from "./ClientsListView.vue?vue&type=script&lang=js"
export * from "./ClientsListView.vue?vue&type=script&lang=js"

import "./ClientsListView.vue?vue&type=style&index=0&id=6a0777f8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a0777f8"]])

export default __exports__